<template>
	<v-app-bar app>
		<v-app-bar-nav-icon @click.stop="setDrawer()" />
		<v-spacer />
		<v-btn icon>
			<v-icon @click="$auth.logout()">mdi-logout</v-icon>
		</v-btn>
	</v-app-bar>
</template>

<script>
import { mapMutations } from "vuex";

export default {
	methods: {
		setDrawer() {
			this.drawer(!this.getDrawer);
		},
		...mapMutations({
			drawer: "base/drawer",
		}),
	},
	computed: {
		getDrawer: {
			get() {
				return this.$store.getters["base/drawer"];
			},
			set(val) {
				this.drawer(val);
			},
		},
	},
};
</script>

<style>
#app-drawer .v-toolbar:not(.v-toolbar--fixed) .v-toolbar__content {
	margin-left: 260px;
}
</style>
